import { GetUserDashboardSummaryResponse } from './User.api.type';

export const userInitializer = {
  INITIAL_USER_DASHBOARD_SUMMARY: {
    totalCreatedSurveyCount: 0,
    totalParticipatedSurveyCount: 0,
    totalCommentCount: 0,
  } as GetUserDashboardSummaryResponse,
};
